export var sanitizeUfoName = function sanitizeUfoName(name) {
  return name.replace(/_/g, '-');
};